import { observable, action } from "mobx";
import moment from 'moment';

export default class CustomFilterStore {

    @observable dateRange = {
        fromDate: moment(),
        toDate: moment()
    }

    @action updateDateRange(key, value) {
        this.dateRange[key] = value;
    }

    @action reset() {
        this.dateRange.fromDate = moment();
        this.dateRange.toDate = moment();
    }
}


// WEBPACK FOOTER //
// ./src/app/stores/CustomFilterStore.js